import type { Connection } from './types'
import type { ActivityRetentionYears } from './activityRetention'

export interface ConnectionDetail extends Connection {
  activity_retention_years?: ActivityRetentionYears
  legal_identity_country?: string | null
  import_from: string | null
  external_url: string | null
  credentials: { name: string; secret: boolean; set: boolean }[]
}
export interface ConnectionType {
  type: string
  credential_method: string
  credential_fields: { name: string; secret: boolean; key?: string; required?: boolean }[]
}
export interface SyncRun {
  id: number
  started_at: string
  finished_at: string | null
  trigger: string
  status: string
  failure_kind: string | null
  log: string
  fetched: number
  created: number
  updated: number
  unchanged: number
  unmatched: number
  errored: number
}
export interface RecordError {
  id: number
  kind: string
  source_type: string
  external_id: string
  link: string | null
  message: string
  first_seen_at: string
  last_seen_at: string
  occurrences: number
  resolved_at: string | null
}
export interface ConnectionAudit {
  id: number | string
  event: string
  actor: { name: string }
  occurred_at: string
  details: Record<string, unknown>
}
export const words = (value: string) => {
  const text = value.replaceAll('_', ' ')
  return text.charAt(0).toUpperCase() + text.slice(1)
}
